document.addEventListener('DOMContentLoaded', function () {
  var widgets = document.querySelectorAll('.js-multiselect');
  if (!widgets.length) {
    return;
  }

  Array.prototype.forEach.call(widgets, function (el) {
    var button = el.querySelector('.multi-select__display');
    var dropdown = el.querySelector('.multi-select__dropdown');
    var checkboxes = dropdown.querySelectorAll('input[type="checkbox"]');

    if (!button || !dropdown || !checkboxes.length) {
      return;
    }

    function updateText() {
      var labels = [];
      Array.prototype.forEach.call(checkboxes, function (cb) {
        if (cb.checked) {
          labels.push(cb.nextElementSibling.textContent.trim());
        }
      });

      var placeholder = button.getAttribute('data-placeholder') || 'Auswahl';
      button.textContent = labels.length ? labels.join(', ') : placeholder;
    }

    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var isOpen = dropdown.classList.toggle('is-open');
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    Array.prototype.forEach.call(checkboxes, function (cb) {
      cb.addEventListener('change', updateText);
    });

    document.addEventListener('click', function (e) {
      if (!el.contains(e.target)) {
        dropdown.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      }
    });

    // initialer Text (falls später mal Vorauswahl kommt)
    updateText();
  });
});
